import { axiosPost, axiosPut } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls, roles } from 'consts'
import { getCustomData } from 'shared/components/App/Auth'
import displayGenError from 'shared/utils/displayGenError'
import hasAnyRole from 'shared/utils/hasAnyRole'
import setFormValidationError from 'shared/utils/setFormValidationError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  setError: Function
  id: string | undefined
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  const isAdmin = hasAnyRole([roles.superAdmin, roles.admin])
  const isSuperAdmin = hasAnyRole([roles.superAdmin])
  const currentUserId = getCustomData('userId')

  //remove relational attributes used in react-select and replace by relational keys
  //nullish-safe operator || '' is important, b/c if we replaced '' by null then no data will be received in the model,
  //so the value won't be overwritten
  props.data['country_id'] = props.data.country?.id ?? ''
  props.data['state_id'] = props.data.state?.id ?? ''
  props.data['role_api'] = props.data.role ?? ''

  delete props.data['role']

  const formData = {
    ...props.data,
  }

  const catchFn = (err: AxiosError) => {
    if (err.response!.status === 422) {
      setFormValidationError(err, props.setError)
    } else {
      displayGenError({ setShowOverlay: props.setShowOverlay })
    }
  }

  if (props.id === undefined) {
    response = await axiosPost(apiUrls.superadmins, formData, catchFn).then((res) => {
      return res
    })
  } else {
    response = await axiosPut(apiUrls.superadmins + '/' + props.id, formData, catchFn).then(
      (res) => {
        return res
      },
    )
  }

  return response
}

export default submitForm
